<div class="card-default" [ngClass]="{'--theme-unico': !newBrand}">
  <div class="card-default__header">
      <div><h3>{{header}}</h3></div>
        <button *ngIf="(editable || delete || ignore || !considerable) && initialized && !newBrand" class="card-default__open-settings" [ngClass]="{'active': action}" (click)="openActions($event)" attr.data-test="btnActions{{itemId}}">
          <span class="card-default__icon"></span>
          <span class="card-default__icon"></span>
          <span class="card-default__icon"></span>
      </button>
      <ul *ngIf="(editable || delete || ignore || !considerable) && action && !newBrand" class="card-default__settings-menu" attr.data-test="listActions{{itemId}}">
          <li *ngIf="editable"><a class="--button-edit" (click)="activeEdit()" attr.data-test="btnEdit{{itemId}}">Editar</a></li>

          <li *ngIf="ignore && ((infos?.code !== 320 && infos?.code !== 340) && (infos?.status !== 320 && infos?.status !== 340))"><a class="--button-ignore" (click)="actionDocument()" attr.data-test="btnIgnore{{itemId}}">Desconsiderar</a></li>
          <li *ngIf="ignore && (infos?.code === 320 || infos?.status === 320)"><a class="--button-ignore" (click)="actionDocument()" attr.data-test="btnReconsider{{itemId}}">Reconsiderar</a></li>

          <li *ngIf="!considerable && ((infos?.code !== 300 && infos?.code !== 340) && (infos?.status !== 300 && infos?.status !== 340))"><a class="--button-ignore" (click)="actionDocument()" attr.data-test="btnIgnore{{itemId}}">Desconsiderar</a></li>
          <li *ngIf="!considerable && (infos?.code === 300 || infos?.status === 300)"><a class="--button-ignore" (click)="actionDocument()" attr.data-test="btnReconsider{{itemId}}">Reconsiderar</a></li>

          <li *ngIf="infos?.additional"><a class="--button-delete" (click)="deleteDocument()">Excluir</a></li>
      </ul>
      <button *ngIf="(editable || delete || ignore || !considerable) && initialized && newBrand && !editing" (click)="activeEdit()" [disabled]="disabledEdit" class="card-default__action-button" attr.data-test="btnEdit{{itemId}}">Editar</button>
  </div>
  <div droppable class="card-default__content" *ngIf="!editing">
      <ng-content class="card-holder" select=".static"></ng-content>
  </div>
  <div class="card-content-form" *ngIf="editing">
      <ng-content class="card-holder" select=".editing"></ng-content>
  </div>
</div>
